import { CapoPlugin } from "/home/gitlab-runner/builds/pG9KGa4F5/0/sim-sol/website/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];